<div [style.rowGap]="formattedRowGap" class="flex relative flex-col">
  @for (item of [].constructor(rows()); track $index) {
    <div
      [style.height]="formattedHeight"
      class="w-full relative rounded-xl overflow-hidden">
      <app-skeleton />
    </div>
  }
</div>
